/* Provador Virtual JM.

   Recomenda o tamanho comparando o CORPO da pessoa com a Tabela de Medidas REAL
   do produto (metaobjeto). É segmentado por sexo em três frentes:

   1) LEITURA DA TABELA — a linha do tórax se chama "Busto" nas tabelas femininas
      e "Peito" (ou "Tórax") nas masculinas. Antes só "busto" era reconhecido, e
      nos jalecos masculinos a medida mais importante da peça era descartada em
      silêncio: a recomendação saía apenas por cintura e quadril.
   2) ESTIMATIVA DO CORPO — fórmulas antropométricas distintas. O corpo masculino
      tem tórax maior e quadril menor em relação a altura/IMC; aplicar a fórmula
      feminina a um homem erra de forma sistemática.
   3) CAIMENTO — o que é "folgado" depende do corte. A tabela masculina é um tubo
      reto (peito ≈ cintura ≈ quadril), então uma cintura com ~19 cm de folga é o
      caimento CORRETO, não um defeito — e a régua antiga marcava isso como "bem
      folgado" e penalizava. Por isso o julgamento passou a ser sobre a FOLGA
      (peça − corpo), com faixa ideal por medida e por sexo.

   O perfil é resolvido pelo PRODUTO, sem perguntar nada: quem abriu um jaleco
   masculino está comprando um jaleco masculino. A cadeia de sinais é
   `custom.genero` → gênero alvo da categoria Shopify → título/tags (tudo isso
   no Liquid, campo `profile`) → nome da linha do tórax da tabela (aqui). O
   catálogo, que troca a tabela ao selecionar outro modelo, reavalia o perfil a
   cada troca.

   As medidas persistem no navegador (localStorage); o perfil não, porque ele
   pertence ao produto que está aberto. */
(function () {
  var modal = document.querySelector('[data-jm-provador]');
  if (!modal || modal.dataset.jmProvInit) return;
  modal.dataset.jmProvInit = '1';

  var KEY = 'jm-provador';

  /* ---------- medidas e sinônimos ----------
     A tabela é digitada à mão pela loja, então aceitamos as grafias que existem
     de verdade nos produtos. Comparação sem acento e por PREFIXO: "Peito (cm)"
     casa com peito, e "Comp. Manga"/"Ombro"/"Veste" não casam com nada (não há
     entrada corporal correspondente para elas). */
  var MEASURES = [
    { id: 'chest', names: ['busto', 'peito', 'torax', 'peitoral'] },
    { id: 'waist', names: ['cintura'] },
    { id: 'hip', names: ['quadril', 'cadeira'] },
  ];

  function deaccent(value) {
    return String(value || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').trim();
  }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }

  /* ---------- perfis ----------
     estimate: regressão sobre altura e IMC (cm), ajustada para cair na grade de
       cada sexo em corpos de referência (fem. 1,65 m/65 kg → 93/77/101;
       masc. 1,75 m/75 kg → 100/87/98).
     ease: multiplicadores da folga ideal configurada na seção, por medida. O
       lojista continua mandando na folga base; aqui ela é distribuída conforme o
       corte (a cintura de um jaleco reto aceita muito mais folga que o tórax).
     weight: peso de cada medida na escolha do tamanho. O tórax é o que decide se
       a peça fecha e cai bem; a cintura quase não restringe num jaleco. */
  var PROFILES = {
    feminino: {
      key: 'feminino',
      label: 'Feminino',
      chestLabel: 'Busto',
      ranges: { chest: [70, 140], waist: [55, 130], hip: [70, 150] },
      bands: { chest: [28, 46], waist: [20, 38], hip: [30, 48] },
      bandY: { chest: 118, waist: 172, hip: 228 },
      ease: { chest: [1.0, 1.2], waist: [1.2, 2.0], hip: [1.0, 1.4] },
      weight: { chest: 1, waist: 0.5, hip: 0.8 },
      estimate: function (altura, peso, idade) {
        var bmi = peso / Math.pow(altura / 100, 2);
        var age = Math.max(0, idade - 30) * 0.12;
        return {
          chest: 0.35 * altura + 1.9 * bmi - 10,
          waist: 0.25 * altura + 2.2 * bmi - 17 + age,
          hip: 0.30 * altura + 2.1 * bmi + 1,
        };
      },
    },
    masculino: {
      key: 'masculino',
      label: 'Masculino',
      chestLabel: 'Peito',
      ranges: { chest: [75, 160], waist: [60, 150], hip: [75, 150] },
      bands: { chest: [30, 48], waist: [24, 42], hip: [28, 44] },
      bandY: { chest: 115, waist: 175, hip: 225 },
      ease: { chest: [1.1, 1.4], waist: [1.6, 2.6], hip: [1.2, 1.8] },
      weight: { chest: 1, waist: 0.4, hip: 0.6 },
      estimate: function (altura, peso, idade) {
        var bmi = peso / Math.pow(altura / 100, 2);
        var age = Math.max(0, idade - 30) * 0.15;
        return {
          chest: 0.30 * altura + 1.8 * bmi + 3.5,
          waist: 0.20 * altura + 2.6 * bmi - 12 + age,
          hip: 0.26 * altura + 1.7 * bmi + 11,
        };
      },
    },
  };

  /* ---------- estado ---------- */
  function load() {
    try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; }
  }
  function save() {
    try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {}
  }
  var EMPTY = {
    altura: null, peso: null, idade: null,
    chest: null, waist: null, hip: null, done: false,
  };
  var state = Object.assign({}, EMPTY, load() || {});
  // Medidas salvas antes da segmentação usavam "bust"; e o perfil já foi
  // escolha da cliente — hoje vem do produto, então não sobrevive no estado.
  if (state.chest == null && state.bust != null) state.chest = state.bust;
  delete state.bust;
  delete state.profile;
  delete state.profileLocked;

  var productProfile = 'feminino';
  function profile() { return PROFILES[productProfile] || PROFILES.feminino; }
  function measureLabel(id) {
    if (id === 'chest') return profile().chestLabel;
    return id === 'waist' ? 'Cintura' : 'Quadril';
  }

  /* ---------- tabela do produto ----------
     O catálogo reutiliza uma única instância do provador e troca a tabela ao
     selecionar outro modelo. A PDP continua inicializando pela tag JSON local. */
  var chart = null;
  var usable = false;

  function setChart(parsed) {
    chart = { columns: (parsed && parsed.columns) || [], rows: {}, labels: {} };
    ((parsed && parsed.rows) || []).forEach(function (line) {
      var parts = String(line).split('|').map(function (p) { return p.trim(); });
      var name = deaccent(parts[0]);
      MEASURES.forEach(function (m) {
        if (chart.rows[m.id]) return;
        if (m.names.some(function (n) { return name.indexOf(n) === 0; })) {
          chart.rows[m.id] = parts.slice(2).map(parseRange);
          chart.labels[m.id] = parts[0];
        }
      });
    });

    /* Medidas da PEÇA vs. do CORPO.
       Jaleco é artesanal e precisa de folga de vestibilidade: se a tabela traz a
       medida da peça (ex.: peito 106), o corpo que veste bem é bem menor. No
       modo auto: valores únicos = peça; faixas = corpo. Os valores da tabela são
       guardados CRUS — a folga é calculada na hora de julgar o caimento, porque
       a folga ideal muda por medida e por sexo. */
    chart.easeMin = parsed && typeof parsed.easeMin === 'number' ? parsed.easeMin : 4;
    chart.easeMax = parsed && typeof parsed.easeMax === 'number' ? parsed.easeMax : 10;
    if (chart.easeMax <= chart.easeMin) chart.easeMax = chart.easeMin + 6;

    var mode = (parsed && parsed.mode) || 'auto';
    if (mode === 'auto') {
      var single = 0, ranged = 0;
      Object.keys(chart.rows).forEach(function (k) {
        chart.rows[k].forEach(function (r) {
          if (!r) return;
          if (r.min === r.max) single++; else ranged++;
        });
      });
      mode = single >= ranged ? 'garment' : 'body';
    }
    chart.mode = mode;

    // Perfil do PRODUTO. O campo `profile` vem resolvido do Liquid (metacampo
    // de gênero → categoria → título/tags); se não vier, o nome da linha do
    // tórax da tabela resolve — Busto é feminino, Peito/Tórax é masculino.
    var chestLabel = deaccent(chart.labels.chest);
    var antes = productProfile;
    if (parsed && PROFILES[parsed.profile]) productProfile = parsed.profile;
    else if (chestLabel.indexOf('busto') === 0) productProfile = 'feminino';
    else if (chestLabel) productProfile = 'masculino';

    // Trocou de produto no catálogo e o perfil mudou: a fórmula do corpo é
    // outra, então as medidas estimadas precisam ser recalculadas.
    if (productProfile !== antes && state.altura && state.peso && state.idade) {
      estimateInto(state.altura, state.peso, state.idade);
      save();
    }

    usable = !!(chart && chart.columns.length && Object.keys(chart.rows).length);
    applyProfileToUi();
    renderControls();
    if (modal.classList.contains('is-open') && state.done) renderResult();
    return usable;
  }

  function parseRange(cell) {
    if (!cell || cell === '—' || cell === '-') return null;
    var nums = String(cell).replace(',', '.').match(/\d+(?:\.\d+)?/g);
    if (!nums) return null;
    var a = parseFloat(nums[0]);
    var b = nums.length > 1 ? parseFloat(nums[1]) : a;
    return { min: Math.min(a, b), max: Math.max(a, b) };
  }

  /* ---------- caimento ----------
     Modo PEÇA: julga a FOLGA (peça − corpo) contra a faixa ideal daquela medida
     naquele sexo. Modo CORPO: a tabela já diz o corpo que serve, então julga a
     distância até a faixa. Nos dois, apertar pesa muito mais que sobrar — jaleco
     justo trava o movimento; jaleco com folga só cai mais solto. */
  function easeBand(id) {
    var factor = profile().ease[id];
    var lo = chart.easeMin * factor[0];
    var hi = chart.easeMax * factor[1];
    return { lo: lo, hi: hi, tight: lo * 0.7, loose: hi * 1.6 };
  }

  function fit(text, cls, penalty, pos, ease) {
    return { text: text, cls: cls, penalty: Math.max(0, penalty), pos: clamp(pos, -1, 1), ease: ease };
  }

  function gradeGarment(id, user, cell) {
    var band = easeBand(id);
    var w = profile().weight[id];
    var ease = (cell.min + cell.max) / 2 - user;
    var mid = (band.lo + band.hi) / 2;
    var pos = ease >= mid
      ? -clamp((ease - mid) / Math.max(1, band.loose - mid), 0, 1)
      : clamp((mid - ease) / Math.max(1, mid - band.tight), 0, 1);

    if (ease < band.tight - 3) return fit('muito justo', 'mjusto', w * (14 + (band.tight - ease) * 3), pos, ease);
    if (ease < band.tight) return fit('justo', 'justo', w * (8 + (band.tight - ease) * 3), pos, ease);
    if (ease < band.lo) return fit('levemente justo', 'ljusto', w * (band.lo - ease) * 2, pos, ease);
    // Dentro do ideal ainda sobra um termo mínimo pela distância até o CENTRO da
    // faixa. Sem ele, dois tamanhos "ideais" empatam em zero e a escolha cairia
    // numa regra arbitrária — e jaleco se veste POR CIMA da roupa, então o meio
    // da faixa é melhor que a borda apertada.
    if (ease <= band.hi) return fit('ideal', 'ideal', w * Math.abs(ease - mid) * 0.08, pos, ease);
    if (ease <= band.loose) return fit('folgado', 'folgado', w * (ease - band.hi) * 0.45, pos, ease);
    return fit('bem folgado', 'bfolgado', w * (6 + (ease - band.loose) * 0.8), pos, ease);
  }

  function gradeBody(id, user, cell) {
    var w = profile().weight[id];
    if (user > cell.max) {
      var over = user - cell.max;
      if (over > 4) return fit('muito justo', 'mjusto', w * (12 + over * 2.5), clamp(over / 6, 0, 1), null);
      if (over > 1.5) return fit('justo', 'justo', w * (6 + over * 2.5), clamp(over / 6, 0, 1), null);
      return fit('levemente justo', 'ljusto', w * (3 + over * 2), clamp(over / 6, 0, 1), null);
    }
    if (user < cell.min) {
      var under = cell.min - user;
      var neg = -clamp(under / 12, 0, 1);
      if (under > 9) return fit('bem folgado', 'bfolgado', w * (4 + (under - 9) * 0.8), neg, null);
      if (under > 4) return fit('folgado', 'folgado', w * (1.5 + (under - 4) * 0.4), neg, null);
      return fit('levemente folgado', 'lfolgado', w * 0.3, neg, null);
    }
    // Mesmo desempate do modo peça: dentro da faixa, quanto mais perto do meio.
    var center = (cell.min + cell.max) / 2;
    return fit('ideal', 'ideal', w * Math.abs(user - center) * 0.08, 0, null);
  }

  function evaluateSize(index) {
    var penalty = 0;
    var fits = [];
    MEASURES.forEach(function (m) {
      var cells = chart.rows[m.id];
      var user = state[m.id];
      if (!cells || !cells[index] || !user) return;
      var g = chart.mode === 'garment' ? gradeGarment(m.id, user, cells[index]) : gradeBody(m.id, user, cells[index]);
      penalty += g.penalty;
      fits.push({ id: m.id, label: measureLabel(m.id), text: g.text, cls: g.cls, pos: g.pos, ease: g.ease });
    });
    return { penalty: penalty, fits: fits };
  }

  function recommend() {
    var best = 0, bestPenalty = Infinity;
    chart.columns.forEach(function (_, i) {
      var hasData = MEASURES.some(function (m) { return chart.rows[m.id] && chart.rows[m.id][i]; });
      if (!hasData) return;
      var p = evaluateSize(i).penalty;
      if (p < bestPenalty) { bestPenalty = p; best = i; }
    });
    return best;
  }

  /* ---------- UI ---------- */
  var steps = {};
  modal.querySelectorAll('[data-jm-step]').forEach(function (el) { steps[el.dataset.jmStep] = el; });
  function show(step) {
    Object.keys(steps).forEach(function (k) { steps[k].hidden = k !== step; });
    modal.querySelector('.jm-prov__panel').scrollTop = 0;
  }

  function open() {
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('jm-prov-lock');
    applyProfileToUi();
    // só pula pro resultado se a pessoa CONCLUIU o fluxo antes (done)
    if (state.done && state.chest && state.waist && state.hip) {
      renderResult();
      show('result');
    } else {
      fillInputs();
      show('1');
    }
  }
  function close() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('jm-prov-lock');
  }

  window.JMProvador = {
    open: function (nextChart) {
      if (nextChart) setChart(nextChart);
      open();
    },
    close: close,
    setChart: setChart,
  };

  document.querySelectorAll('[data-jm-provador-open]').forEach(function (btn) {
    btn.addEventListener('click', open);
  });
  modal.querySelectorAll('[data-jm-prov-close]').forEach(function (btn) { btn.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
  });

  /* etapa 1 — perfil + dados */
  var inAltura = modal.querySelector('[data-jm-prov-altura]');
  var inPeso = modal.querySelector('[data-jm-prov-peso]');
  var inIdade = modal.querySelector('[data-jm-prov-idade]');
  var errEl = modal.querySelector('[data-jm-prov-error]');

  function applyProfileToUi() {
    var p = profile();
    modal.querySelectorAll('[data-jm-silhouette]').forEach(function (el) {
      el.style.display = el.dataset.jmSilhouette === p.key ? '' : 'none';
    });
    MEASURES.forEach(function (m) {
      var label = measureLabel(m.id);
      var box = modal.querySelector('[data-jm-measure="' + m.id + '"]');
      if (!box) return;
      var text = box.querySelector('[data-jm-label]');
      if (text) text.textContent = label;
      var range = box.querySelector('[data-jm-range]');
      if (range) {
        range.min = String(p.ranges[m.id][0]);
        range.max = String(p.ranges[m.id][1]);
        range.setAttribute('aria-label', label + ' em centímetros');
      }
      var dec = box.querySelector('[data-jm-dec]');
      var inc = box.querySelector('[data-jm-inc]');
      if (dec) dec.setAttribute('aria-label', 'Diminuir ' + label.toLowerCase());
      if (inc) inc.setAttribute('aria-label', 'Aumentar ' + label.toLowerCase());
      var band = modal.querySelector('[data-jm-band="' + m.id + '"]');
      if (band) {
        var y = p.bandY[m.id];
        band.querySelectorAll('line').forEach(function (line, i) {
          line.setAttribute('y1', String(y + i * 7));
          line.setAttribute('y2', String(y + i * 7));
        });
      }
    });
  }

  function fillInputs() {
    if (state.altura) inAltura.value = state.altura;
    if (state.peso) inPeso.value = state.peso;
    if (state.idade) inIdade.value = state.idade;
  }

  function estimateInto(altura, peso, idade) {
    var p = profile();
    var est = p.estimate(altura, peso, idade);
    MEASURES.forEach(function (m) {
      var limits = p.ranges[m.id];
      state[m.id] = clamp(Math.round(est[m.id]), limits[0], limits[1]);
    });
  }

  modal.querySelector('[data-jm-prov-next1]').addEventListener('click', function () {
    var altura = parseFloat(inAltura.value);
    var peso = parseFloat(inPeso.value);
    var idade = parseFloat(inIdade.value);
    if (!altura || altura < 120 || altura > 220) return err('Informe uma altura entre 120 e 220 cm.');
    if (!peso || peso < 30 || peso > 200) return err('Informe um peso entre 30 e 200 kg.');
    if (!idade || idade < 14 || idade > 99) return err('Informe uma idade entre 14 e 99 anos.');
    err('');
    var changed = state.altura !== altura || state.peso !== peso || state.idade !== idade;
    state.altura = altura; state.peso = peso; state.idade = idade;
    if (changed || !state.chest) estimateInto(altura, peso, idade);
    save();
    applyProfileToUi();
    renderControls();
    show('2');
  });
  function err(msg) { errEl.textContent = msg; return false; }

  /* etapa 2 — ajuste do corpo */
  var controls = {};
  modal.querySelectorAll('[data-jm-measure]').forEach(function (box) {
    var id = box.dataset.jmMeasure;
    var range = box.querySelector('[data-jm-range]');
    var value = box.querySelector('[data-jm-value]');
    controls[id] = { range: range, value: value };
    range.addEventListener('input', function () { setMeasure(id, parseInt(range.value, 10)); });
    box.querySelector('[data-jm-dec]').addEventListener('click', function () { setMeasure(id, state[id] - 1); });
    box.querySelector('[data-jm-inc]').addEventListener('click', function () { setMeasure(id, state[id] + 1); });
  });

  function setMeasure(id, v) {
    var limits = profile().ranges[id];
    state[id] = clamp(v, limits[0], limits[1]);
    save();
    renderControls();
  }

  function renderControls() {
    var p = profile();
    MEASURES.forEach(function (m) {
      var c = controls[m.id];
      if (!c || !state[m.id]) return;
      c.range.value = state[m.id];
      c.value.textContent = state[m.id] + ' cm';
      // largura da fita na silhueta proporcional à medida (limites por região)
      var band = modal.querySelector('[data-jm-band="' + m.id + '"]');
      if (band) {
        var min = p.ranges[m.id][0], max = p.ranges[m.id][1];
        var t = (state[m.id] - min) / (max - min);
        var lim = p.bands[m.id];
        var half = lim[0] + t * (lim[1] - lim[0]);
        band.querySelectorAll('line').forEach(function (line) {
          line.setAttribute('x1', String(100 - half));
          line.setAttribute('x2', String(100 + half));
        });
      }
    });
  }

  modal.querySelector('[data-jm-prov-back]').addEventListener('click', function () { show('1'); });
  modal.querySelector('[data-jm-prov-next2]').addEventListener('click', function () {
    show('3');
    window.setTimeout(function () {
      state.done = true; // fluxo concluído: próximas aberturas vão direto ao resultado
      save();
      renderResult();
      show('result');
    }, 1100);
  });

  /* resultado */
  var bestEl = modal.querySelector('[data-jm-prov-best]');
  var fitsEl = modal.querySelector('[data-jm-prov-fits]');
  var pillsEl = modal.querySelector('[data-jm-prov-pills]');

  function renderResult(previewIndex) {
    if (!usable) {
      bestEl.textContent = '—';
      fitsEl.innerHTML = '<p class="jm-prov__fit">Este produto ainda não tem tabela de medidas cadastrada.</p>';
      pillsEl.innerHTML = '';
      return;
    }
    var best = recommend();
    var current = typeof previewIndex === 'number' ? previewIndex : best;

    bestEl.textContent = chart.columns[current];
    var evaluation = evaluateSize(current);
    fitsEl.innerHTML = evaluation.fits.map(function (f) {
      // pos [-1..+1] → posição na régua (0% = bem folgado, 42% = ideal, 100% = muito justo)
      var left = 42 + (f.pos < 0 ? f.pos * 42 : f.pos * 58);
      left = Math.max(3, Math.min(97, left));
      // Só a etiqueta do caimento. A folga em cm gerava dúvida ("7 cm é muito?")
      // em vez de confiança — a régua já comunica isso visualmente.
      return '<div class="jm-prov__fit jm-prov__fit--' + f.cls + '">' +
        '<span>' + f.label + '</span>' +
        '<i class="jm-prov__meter" aria-hidden="true"><b style="left:' + left.toFixed(1) + '%"></b></i>' +
        '<em>' + f.text + '</em>' +
      '</div>';
    }).join('') || '<p class="jm-prov__fit">Sem medidas corporais na tabela.</p>';

    pillsEl.innerHTML = chart.columns.map(function (col, i) {
      var hasData = MEASURES.some(function (m) { return chart.rows[m.id] && chart.rows[m.id][i]; });
      if (!hasData) return '';
      var cls = (i === current ? ' class="is-active' + (i === best ? ' is-best' : '') + '"' : (i === best ? ' class="is-best"' : ''));
      return '<button type="button"' + cls + ' data-index="' + i + '">' + col + '</button>';
    }).join('');
    pillsEl.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () { renderResult(parseInt(b.dataset.index, 10)); });
    });
  }

  modal.querySelector('[data-jm-prov-edit]').addEventListener('click', function () {
    fillInputs();
    applyProfileToUi();
    renderControls();
    show('1');
  });

  /* reiniciar: limpa tudo e recomeça o fluxo do zero */
  modal.querySelector('[data-jm-prov-reset]').addEventListener('click', function () {
    try { localStorage.removeItem(KEY); } catch (e) {}
    state = Object.assign({}, EMPTY, { profile: productProfile });
    inAltura.value = '';
    inPeso.value = '';
    inIdade.value = '';
    err('');
    applyProfileToUi();
    show('1');
  });

  try {
    var raw = document.querySelector('[data-jm-prov-chart]');
    setChart(JSON.parse(raw.textContent));
  } catch (e) {
    chart = null;
    usable = false;
    applyProfileToUi();
  }
})();
